import React, { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Clock, Tag } from "lucide-react";
import "../style/cryptonestBlog.css";

// Assets
import hero1 from "../assets/web3.webp";
import hero2 from "../assets/updateanaltyics.webp";
import hero3 from "../assets/solanaecosystem.webp";
import card1 from "../assets/insights.webp";
import card2 from "../assets/rwa.webp";
import card3 from "../assets/2fa.webp";

const filters = ["All", "Guides", "Education", "Insights", "Product"];

// New dynamic content data
const FEATURED_STORIES = [
  {
    img: card1,
    category: "Insights",
    title: "The Sovereign AI: Navigating 2026 DeFi",
    desc: "How autonomous agents are now managing liquidity across protocols without human intervention.",
    readTime: "6 min"
  },
  {
    img: card2,
    category: "Education",
    title: "RWA: The Multi-Trillion Dollar Bridge",
    desc: "A deep dive into how institutional real-world assets are migrating to the Ethereum mainnet.",
    readTime: "8 min"
  },
  {
    img: card3,
    category: "Product",
    title: "Security 3.0: Beyond 2FA",
    desc: "Introducing VaultX Crypto's new MPC-based recovery system for ultimate wallet peace of mind.",
    readTime: "4 min"
  }
];

export default function CryptoNestBlog() {
  const [activeFilter, setActiveFilter] = useState("All");

  return (
    <div className="crypto-blog-theme">
      <div className="blog-container">
        <div className="mesh-gradient"></div>
        <div className="noise-overlay"></div>

        <header className="modern-header">
          <motion.div 
            initial={{ opacity: 0, x: -20 }} 
            animate={{ opacity: 1, x: 0 }}
            className="header-left"
          >
            <span className="eyebrow">The VaultX Crypto Journal</span>
            <h1>Decoding the <span>Digital Economy</span></h1>
          </motion.div>

          <nav className="filter-pill-bar">
            {filters.map((f) => (
              <button 
                key={f}
                onClick={() => setActiveFilter(f)}
                className={activeFilter === f ? "active" : ""}
              >
                {f}
                {activeFilter === f && (
                  <motion.div layoutId="pill-bg" className="pill-bg" transition={{ type: "spring", bounce: 0.3, duration: 0.6 }} />
                )}
              </button>
            ))}
          </nav>
        </header>

        {/* BENTO HERO SECTION */}
        <section className="bento-grid">
          {/* Main Feature */}
          <motion.article 
            className="bento-item main-feature"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            whileHover={{ y: -5 }}
          >
            <div className="image-wrapper">
              <img src={hero1} alt="The New Web3 Standard" />
              <div className="overlay-gradient"></div>
            </div>
            <div className="bento-content">
              <span className="badge-glass">Top Story</span>
              <h2>The Modular Future: Why Monolithic Blockchains are Evolving</h2>
              <p>Explore the shift toward specialized layers for data availability and execution.</p>
              <div className="meta">
                <span><Clock size={14} /> 12 min read</span>
                <button className="circle-btn"><ArrowUpRight /></button>
              </div>
            </div>
          </motion.article>

          {/* Side Feature Top */}
          <motion.article 
            className="bento-item side-feature"
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <img src={hero2} alt="Analytics 2.0" />
            <div className="bento-content">
              <span className="badge-glass purple">Market Intelligence</span>
              <h3>Predictive On-Chain Analytics 2.0</h3>
            </div>
          </motion.article>

          {/* Side Feature Bottom */}
          <motion.article 
            className="bento-item side-feature bottom"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <img src={hero3} alt="Solana Ecosystem" />
            <div className="bento-content">
              <span className="badge-glass green">Ecosystem Report</span>
              <h3>Solana’s Path to Mass Adoption</h3>
              <ArrowUpRight className="icon-top-right" />
            </div>
          </motion.article>
        </section>

        {/* SECONDARY FEED */}
        <section className="article-feed">
          <div className="section-title">
            <h2>Latest Perspectives</h2>
            <div className="line"></div>
          </div>

          <div className="feed-grid">
            {FEATURED_STORIES.map((story, i) => (
              <motion.div 
                key={i}
                className="feed-card"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.02 }}
              >
                <div className="feed-img">
                  <img src={story.img} alt={story.title} />
                </div>
                <div className="feed-info">
                  <span className="category"><Tag size={12} style={{marginRight: '4px'}}/> {story.category}</span>
                  <h4>{story.title}</h4>
                  <p>{story.desc}</p>
                  <div className="feed-meta">
                    <Clock size={12} /> {story.readTime}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}